module.exports = __webpack_public_path__ + "img/loginLogo.24e7dcec.png";